/* eslint class-methods-use-this: ["off"] */
/* eslint arrow-parens: ["off"] */

import { Node } from 'tiptap';

export default class Image extends Node {
  get name() {
    return 'image';
  }

  get schema() {
    return {
      attrs: {
        src: {
          default: null,
        },
      },
      group: 'block',
      selectable: false,
      parseDOM: [{
        tag: 'img',
        getAttrs: dom => ({
          src: dom.getAttribute('src'),
        }),
      }],
      toDOM: node => ['img', {
        src: node.attrs.src,
      }],
    };
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      computed: {
        src: {
          get() {
            return this.node.attrs.src;
          },
          set(src) {
            this.updateAttrs({
              src,
            });
          },
        },
      },
      template: `
        <div class="image">
          <img :src="src" />
          <input class="image__input" @paste.stop type="text" v-model="src" v-if="view.editable" />
        </div>`,
    };
  }
}
